<template>
  <div class="content">
    <div class="container-fluid">
      <div class="card">

        <div class="card-header">
          <router-link to="/select-option" class="btn btn-default btn-simple">
            <i class="fa fa-arrow-left"></i> <span class="card-title">Back</span>
          </router-link>
        </div>

        <div class="card-body">

          <h2>SQAaaS lets you create customized CI/CD pipelines</h2>

          <div class="criteria-description">
            <div class="text">
              <div class="title">Quality criteria define the CI/CD pipeline work</div>
              <div>It is the underpinning part where the pipeline’s purpose takes shape.</div>
              <div>The associated properties for each criterion will be displayed once selected in the dropdown list below.</div>
            </div>
            <img class="icon" src="../../static/criteria.png" alt="Quality criteria">
          </div>

          <div class="pipeline-name">
            <div class="title">Choose a name for the pipeline</div>
            <input type="text" class="form-control" v-model="pipeline_name">
            <div class="error" v-show="!validPipelineName"><i class="fa fa-exclamation-triangle"></i> Error: Invalid character</div>
            <div v-show="error_pipeline_name" class="error"> <i class="fa fa-exclamation-triangle"></i> Error: Pipeline name is required</div>
          </div>

          <div class="custom_envs">

            <base-checkbox class="custom_envs_checkbox" label="Customize Environment"  help="Define here the environment variables that will be furtherly used by the pipeline" link="https://docs.sqaaas.eosc-synergy.eu/pipeline_as_a_service/step_1_repositories#environment" v-model="custom_env.checkbox" />

            <div v-if="custom_env.checkbox">

              <div class="custom_envs_input">
                <base-input class="custom_env_input_key" type="text" required label="Key" addon-left-icon="fa fa-key" v-model="custom_env.input.key" />
                <base-input class="custom_env_input_value" type="text" required label="Value" addon-left-icon="fa fa-align-left" v-model="custom_env.input.value" />
                <button class="btn btn-primary btn-fill custom_env_add" @click="addCustomEnv()"><i class="fa fa-plus"></i> Add</button>
                <div v-show="custom_env.error_input" class="error"> <i class="fa fa-exclamation-triangle"></i> Error: Key and value are required</div>
              </div>

              <div v-if="this.custom_env.added.length > 0" class="custom_envs_added">
                <div class="title">Configured Environment</div>

                <div v-for="(env, index) in this.custom_env.added" class="custom_envs_list">
                  <div class="custom_env_key_value">{{ env.key }}: {{ env.value }}</div>
                  <button type="button" class="btn-simple btn btn-xs custom_env_delete" @click="removeCustomEnv(index)"><i class="fa fa-trash"></i></button>
                </div>
              </div>

            </div>
          </div>

          <div class="criteria">

           <div class="row">
             <div class="col-xl-6 criteria-input">

               <div class="title">Criteria and Tools Selection</div>

               <label>Choose a Criterion</label>
               <div v-if="!api_criteria.length > 0" class="ssc-head-line" />
                <div v-else class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text"> <i class="fa fa-compass"></i> </span>
                  </div>
                  <select class="custom-select criteria_list" v-model='criteria.criterion_selected'>
                    <option v-show="criteria.criterion_selected" value="">None</option>
                    <option disabled class="criteria_input_section">Software</option>
                    <option v-for="(criteria,key) in api_criteria" v-if="criteria.type === 'software'" :key="key" :value="criteria">{{criteria.id}}</option>
                    <option disabled class="criteria_input_section">Service</option>
                    <option v-for="(criteria,key) in api_criteria" v-if="criteria.type === 'service' && criteria.id !== 'SvcQC.Fun'" :key="key" :value="criteria">{{criteria.id}}</option> <!-- SvQC.Fun has not been tested yet -->
                  </select>
                </div>


                <div v-if="criteria.criterion_selected">
                  <div class="criteria_info">
                    <div><span class="badge badge-info">Scope</span> {{ criteria.criterion_selected.description.msg }} (<a :href="criteria.criterion_selected.description.docs" target="_blank">more details</a>)</div>
                    <div><span class="badge badge-info">Improves</span> {{ criteria.criterion_selected.description.improves }}</div>
                  </div>


                  <div class="tool">
                    <div class="tool_input">
                      <label>Choose a tool</label>
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text"> <i class="fa fa-cogs"></i> </span>
                        </div>
                        <select class="custom-select" v-model='criteria.tool.selected'>
                          <option v-for="(tool,key) in criteria.tool.available" :key="key" :value="tool">{{tool.name.toUpperCase()}}</option>
                        </select>
                      </div>
                    </div>


                    <div v-if="criteria.tool.selected">

                      <div class="tool_badges">
                        <span v-if="criteria.tool.custom_image.name" class="badge badge-secondary">image: {{criteria.tool.custom_image.name}}</span>
                        <span v-else>
                          <span v-if="criteria.tool.selected.docker.image" class="badge badge-secondary">image: {{ criteria.tool.selected.docker.image }}</span>
                          <span v-else-if="criteria.tool.selected.docker.dockerfile" class="badge badge-secondary">image: {{ criteria.tool.selected.docker.dockerfile }}</span>
                          <span v-if="criteria.tool.selected.lang" class="badge badge-primary">lang: {{ criteria.tool.selected.lang }}</span>
                          <span v-if="criteria.tool.selected.version" class="badge badge-danger">version: {{ criteria.tool.selected.version }}</span>
                        </span>
                      </div>

                      <div class="external_repo">

                        <base-checkbox class="external_repo_checkbox" label="My tool needs code from external repository"  help="External repository is different from the one that will contain the current pipeline" link="https://docs.sqaaas.eosc-synergy.eu/pipeline_as_a_service/step_1_repositories#defining-repositories" v-model="criteria.tool.external_repo.checkbox" />

                        <div v-if="criteria.tool.external_repo.checkbox">

                          <div class="external_repo_input">

                            <div v-if="externalReposCollection.length > 0" class="external_repo_collection dropdown">
                              <button class="btn btn-secondary dropdown-toggle" type="button" data-toggle="dropdown"> Previous repos</button>
                              <div class="dropdown-menu">
                                <a v-for="repo in externalReposCollection" class="dropdown-item" @click="addRepoInput(repo)"> {{repo.url}} {{repo.branch? "/ "+repo.branch : ""}} </a>
                              </div>
                            </div>

                            <base-input class="external_repo_input_url" type="text" required label="Repository URL" addon-left-icon="fa fa-archive" help="The URL you can use to clone the project" v-model="criteria.tool.external_repo.url" />
                            <base-input class="external_repo_input_branch" type="text" label="Branch" placeholder="master" addon-left-icon="fa fa-code-fork" v-model="criteria.tool.external_repo.branch" />
                          </div>
                          <div class="public_repo"><i class="fa fa-bell"></i> Repository must be public for the checkout to work</div>

                        </div>
                      </div>

                      <div class="tool_args">
                        <div v-for="arg in (criteria.tool.selected.args || []).filter(arg => arg.selectable)" :key="arg.id">

                            <div v-if="arg.format === 'string' && !arg.repeatable" class="form-group">
                              <base-input type="text" :label="arg.description" :required="arg.type === 'positional'" v-model="arg.value" />
                            </div>

                            <div v-else-if="arg.format === 'string' && arg.repeatable" class="form-group">
                              <base-input type="text" :label="arg.description" :required="arg.type === 'positional'" v-model="arg.value" tags />
                            </div>

                            <div v-else-if="arg.format === 'array' && !arg.repeatable" class="form-group">
                              <label :for="arg.id"><span v-if="arg.type === 'positional'" class="required">*</span> {{arg.description}}</label>
                              <select class="custom-select" :id="arg.id" v-model="arg.inputValue">
                                <option selected disabled value=''></option>
                                <option v-for="opt in arg.value" :key="opt" :value="opt">{{opt}}</option>
                              </select>
                            </div>

                        </div>
                      </div>

                      <div class="custom_image">

                        <base-checkbox class="custom_image_checkbox" label="My tool needs a custom public image" help="Define your own image service. This has to be public." v-model="criteria.tool.custom_image.checkbox"/>

                        <div v-if="criteria.tool.custom_image.checkbox">
                          <div class="custom_image_input">
                            <base-input type="text" label="Custom public image" addon-left-icon="fa fa-box" :placeholder="criteria.tool.selected.docker.image" v-model="criteria.tool.custom_image.name" />
                          </div>
                        </div>
                      </div>

                      <div v-show="criteria.tool.error_args" class="error"> <i class="fa fa-exclamation-triangle"></i> Error: Missing required tool arguments</div>
                      <div v-show="criteria.tool.error_tool_already_selected" class="error"> <i class="fa fa-exclamation-triangle"></i> Error: This tool has already been selected for its criterion. Please, delete it before add a new one</div>

                      <button type="button" class="btn btn-primary btn-fill add_tool_button" @click="addTool()"><i class="fa fa-plus"></i> Add {{criteria.tool.selected.name}} tool for {{criteria.criterion_selected.id}} criterion</button>

                    </div>
                  </div>

                </div>

             </div>

             <div class="col-xl-6 criteria-added">

                  <div class="title">Configured Criteria and Tools</div>

                  <div v-if="criteria.added.length > 0">

                    <div v-for="(criterion, criterion_index) in criteria.added" :key="criterion.criterionID">
                      <div class="criteria_item"><i class="fa fa-compass"></i> Criterion: {{criterion.criterionID}}</div>

                      <div v-for="(tool, tool_index) in criterion.tools" :key="tool.tool.name" class="tool_item">
                        <div class="tool_title"><span class="tool_name"><i class="fa fa-cogs"></i> <span class="tool_data_title">Tool:</span> {{tool.tool.name}}</span> <button type="button" class="btn-simple btn btn-xs tool_delete" @click="removeTool(criterion_index, tool_index)"><i class="fa fa-trash"></i></button></div>
                        <div v-if="tool.external_repo.url" class="tool_data"> <span class="tool_data_title">External repo:</span> {{tool.external_repo.url}}/{{tool.external_repo.branch}}</div>
                        <div v-for="arg in tool.tool.args">
                          <div v-if="arg.selectable && arg.format === 'string' && arg.value" class="tool_data"> <span class="tool_data_title">{{arg.description}}:</span> {{arg.value}}</div>
                          <div v-else-if="arg.selectable && arg.format === 'array' && arg.value" class="tool_data"> <span class="tool_data_title">{{arg.description}}:</span> {{arg.inputValue}}</div>
                        </div>
                        <div v-if="tool.image" class="tool_data"> <span class="tool_data_title">Custom public image:</span> {{tool.image}}</div>
                      </div>

                    </div>
                  </div>

                  <div v-else class="no-criteria-selected">
                    No criteria selected yet
                  </div>

             </div>

           </div>


        </div>

          <button class="btn btn-primary btn-fill create-pipeline-button" @click="createPipeline()" type="button" :disabled="criteria.added.length === 0">Create pipeline</button>

        </div>

      </div>
    </div>
  </div>
</template>

<script>

import Card from 'src/components/Cards/Card.vue'
import BaseDropdown from "@/components/BaseDropdown.vue";
import Services from "../services/services";
  export default {

    components: { Card, BaseDropdown },
    mixins: [Services],

    data () {
      return {
        api_criteria: [], // Criteria data from API
        pipeline_name: '', // Name of the pipeline
        error_pipeline_name: false, // Pipeline name is required

        // Custom environment
        custom_env:{
          checkbox: false, // Panel is displayed?
          input: { // Input fields
            key: '',
            value: ''
          },
          error_input: false, // Key and value are required
          added : [] // Total env vars added
          /*
          [{
            key: String,
            value: String
          }]
          */
        },

        // Criteria
        criteria: {
          criterion_selected: undefined, // Criterion (object) selected from drop-down list

          // Tool
          tool: {
            available: [], // Tools available for selected criteria
            selected: undefined, // Tool (object) selected from drop-down list
            // External Repository
            external_repo: { // External repository for the tool
              checkbox: false, // Panel is displayed?
              url: '',
              branch: ''
            },

            // Custom Image
            custom_image:{
              checkbox: false, // Panel is displayed?
              name: '', // Image that replaces tool default image
            },

            error_args: false, // Some tool arguments are required
            error_tool_already_selected: false // The tool has already been selected for its criterion
          },
          added: [] // Set of criteria and tools selected
          /*
          [{
            criterionID: String,
            tools: [{
              tool: Tool,
              repo: {url: String, branch: String},
              image: String
            }]
          }]
          */
        }

      }
    },

    created(){
      this.getCriteriaCall(this.getCriteriaCallBack) // Get data from API
    },
    mounted(){
      $('[data-toggle="tooltip"]').tooltip()

      // Set mutation observer for create Bootstap Tooltip on dynamics ones
      const targetNode = document.getElementsByClassName("criteria")[0];
      const config = { attributes: true, childList: true, subtree: true };
      const callback = (mutationList, observer) => { $('.criteria [data-toggle="tooltip"]').tooltip() };
      const observer = new MutationObserver(callback);
      observer.observe(targetNode, config);
    },

    computed: {
      validPipelineName(){
        const regex = new RegExp("(^$)|^[a-zA-Z0-9_.-]+$");
        return regex.test(this.pipeline_name)
      },
      externalReposCollection(){
        // Total external repositories added during the tools configuration
        let external_repositories =  this.criteria.added.flatMap(criteria => criteria.tools.flatMap(tool => tool.external_repo.url.trim()? tool.external_repo : []))
        // Remove duplicates
        return external_repositories.filter((repo1, index, array) => array.findIndex(repo2 => (repo1.url === repo2.url && repo1.branch === repo2.branch)) === index )
      }
    },

    watch:{
      'pipeline_name'(val){
        if(val) this.error_pipeline_name = false;
      },
      'criteria.tool.external_repo.url'(val){
        if(val) this.criteria.tool.external_repo.error_input_url = false;
      },
      'custom_env.input.key'(val){
        if(val) this.custom_env.error_input = false;
      },
      'custom_env.input.value'(val){
        if(val) this.custom_env.error_input = false;
      },
      'criteria.criterion_selected'(criterion_selected){
        this.criteria.tool.external_repo.checkbox = false
        this.criteria.tool.external_repo.url = ""
        this.criteria.tool.external_repo.branch = ""
        this.criteria.tool.custom_image.checkbox = false
        this.criteria.tool.custom_image.name = ''
        this.criteria.tool.selected = undefined
        this.criteria.tool.available = criterion_selected ? this.api_criteria.find(criterion => criterion.id === criterion_selected.id).tools : []
        this.criteria.tool.error_args = false
      },
      'criteria.tool.selected'(tool_selected){
        this.criteria.tool.error_args = false
      }
    },

    methods:{
      getCriteriaCallBack(response){

        if(response.status === 200){ // 200 OK
          this.api_criteria = response.data;
        }else{
          this.$swal.fire({
            title: 'We are having problems making the request.',
            html: '<div style="font-size: 0.85em">' + response.status + " " + response.statusText + " " + response.config.method.toUpperCase() + " " + response.config.url + '</div>' +
                  '<div style="margin-top: 1.5em">Please, try again in a few minutes.</div>',
            icon: 'error',
            confirmButtonText: 'Close',
            confirmButtonColor: '#E14726',
            footer: '<a style="font-size:18px;color:red; text-decoration:underline;"  href="https://github.com/EOSC-synergy/SQAaaS/issues/new/choose" target="_blank">Report the issue</a>',
          }).then(() => {
            this.$router.push('select-option');
          })
        }
      },

      addCustomEnv(){
        if(!this.custom_env.input.key || !this.custom_env.input.value){
          this.custom_env.error_input = true;
        }else{
          this.custom_env.error_input = false;

          this.custom_env.added.push(
            {
              'key': this.custom_env.input.key.trim(),
              'value': this.custom_env.input.value.trim(),
            }
          )

          this.custom_env.input.key = '';
          this.custom_env.input.value = '';

        }
      },
      removeCustomEnv(index){
        this.custom_env.added.splice(index,1);
      },

      addRepoInput(repo){

        this.criteria.tool.external_repo.url = repo.url
        this.criteria.tool.external_repo.branch = repo.branch
      },

      addTool(){

        if(this.criteria.tool.selected.args && this.criteria.tool.selected.args.filter(arg => arg.type === 'positional').some(arg => (arg.format === "string" && !arg.value.trim()) || (arg.format === "array" && (!arg.inputValue || !arg.inputValue.trim())))){
          this.criteria.tool.error_args = true
          return
        }

        this.criteria.tool.error_args = false
        this.criteria.tool.error_tool_already_selected = false

        let criteria_exist = this.criteria.added.find( criteria => criteria.criterionID === this.criteria.criterion_selected.id)

        if(!criteria_exist){
          this.criteria.added.push({
            criterionID: this.criteria.criterion_selected.id,
            tools: [{
              tool: this.criteria.tool.selected,
              external_repo: {url: this.criteria.tool.external_repo.url, branch: this.criteria.tool.external_repo.branch},
              image: this.criteria.tool.custom_image.name
            }]
          })

        }
        else{
          let tool_exists = criteria_exist.tools.find( tool => tool.tool.name === this.criteria.tool.selected.name)
          if(tool_exists){
            this.criteria.tool.error_tool_already_selected = true
            return
          }
          criteria_exist.tools.push({
            tool: this.criteria.tool.selected,
            external_repo: {url: this.criteria.tool.external_repo.url, branch: this.criteria.tool.external_repo.branch},
            image: this.criteria.tool.custom_image.name
          })
        }


        this.criteria.tool.external_repo.checkbox = false
        this.criteria.tool.external_repo.url = ""
        this.criteria.tool.external_repo.branch = ""
        this.criteria.tool.custom_image.checkbox = false
        this.criteria.tool.custom_image.name = ''
        this.criteria.tool.selected = undefined
        this.criteria.criterion_selected = undefined

      },
      removeTool(criterion_index, tool_index){

        this.criteria.added[criterion_index].tools.splice(tool_index,1)
        if(this.criteria.added[criterion_index].tools.length === 0) this.criteria.added.splice(criterion_index,1)

      },

      createPipeline(){

        this.error_pipeline_name = false

        if(!this.pipeline_name.trim()){
          this.error_pipeline_name = true
          document.getElementsByClassName('pipeline-name')[0].scrollIntoView({ block: "center", behavior: "smooth" });
          return
        }

        // Replace array value by string inputValue on criteria.tool.tool.args
        for (const criteria of this.criteria.added) {
          for(const tool of criteria.tools){
            for(const arg of tool.tool.args){
              if (Array.isArray(arg.value)) arg.value = arg.inputValue
            }
          }
        }


        this.$store.state.criteria = {
          pipeline_name: this.pipeline_name,
          external_repos: this.externalReposCollection,
          custom_env: this.custom_env.added,
          criteria: this.criteria.added
        }

        this.$router.push({name: 'Files'});

      }
    }
}

</script>

<style scoped>

  .card{
    margin: 2em 1.5em;
    background-color: #FAFAFA;

    .card-header{
      padding: 0.6em;
      background-color: #FAFAFA;

      .card-title{
        font-weight: bold;
        padding-left:5px;
        font-size:18px;
      }
    }

    .card-body{
      display: flex;
      flex-direction: column;
      padding: 0;

      h2{
        color: #76BAC6;
        font-weight: bold;
        text-align: center;
        margin-bottom: 2em;
      }

      .criteria-description{
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 4em;
        background: linear-gradient(0deg, rgb(226, 230, 236) 0%, rgba(230,236,237,1) 100%);
        margin-bottom: 3em;
        padding: 2em 10%;

        .text{
          flex-grow: 1;

          div { padding-bottom: 0.5rem; }
          .title{
            font-size: 1.75em;
            font-weight: bold;
          }
        }

        .icon{
          width: 140px;
          opacity: 0.5;
        }

      }

      .pipeline-name{
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 3em;

        .title{
          font-size: 1.2em;
          margin-bottom: 0.5em;
        }

        input {
          width: min(80%, 800px);
        }

        .error{
          color: red;
          font-size: 0.8em;
          padding-top: 1em;
          width: min(80%, 800px);
        }
      }

      .custom_envs{
        margin: 0 5% 3em 5%;

        .custom_envs_input{
          display: grid;
          .custom_env_input_key { grid-area: key }
          .custom_env_input_value { grid-area: value };
          .custom_env_add { grid-area: add; }
          grid: "key value add" / 1fr 1fr;
          align-items: end;
          padding: 0.5em 5%;
          gap: 1em;

          .custom_env_input_key,
          .custom_env_input_value{
            margin-bottom: 0;
          }

          .custom_env_add{
            height: 3em;
            width: 6em;
          }

          .error{
            color: red;
            font-size: 0.8em;
          }
        }

        .custom_envs_added{
          margin: 2em 10%;

          .title{
            padding-top: 5px;
            font-weight: 700;
            text-align: center;
          }

          .custom_envs_list{
            display: flex;
            background: linear-gradient(90deg, #F1F1F1 0%, #F8F8FA 100%);
            margin: 0.5em;
            padding: 0.5em 1em;
            border-radius: 5px;
            border: solid 1px #d4dadf;

            .custom_env_key_value {
              flex-grow: 2
            }

            .custom_env_delete .fa-trash{
              font-size: 15px;
              color: #ea6262;
            }
          }
        }
      }

      .criteria{
        margin: 0 5% 2em 5%;

        .criteria-input{
          border-right: 1px solid lightgrey;
          padding-right: 2em;

          .title{
            padding-top: 5px;
            font-weight: 700;
            text-align: center;
          }

          .ssc-head-line{
            margin: 7px 0;
          }

          .criteria_input_section{
            background-color: #e7eaf1;
            color: #062657;
            font-weight: bold;
          }

          .criteria_info{
            margin-left: 2em;
            div { padding-top: 0.5em; }
          }

          .tool{
            padding: 1em 2em 0 2em;


            .tool_badges{
              margin-top: 0.5em;
              margin-left: 2em;

              .badge{
                margin-right: 0.7em;
              }
            }

            .external_repo{

              .external_repo_checkbox{
                padding-left: 2em;
                padding-top: 1em;
              }

              .external_repo_input{
                display: flex;
                align-items: end;
                padding: 0.5em 3em;
                gap: 1em;

                .external_repo_collection,
                .external_repo_input_url,
                .external_repo_input_branch{
                  margin-bottom: 0.2em;
                }

                .external_repo_collection a{
                  cursor: pointer;
                }

              }

              .public_repo{
                font-style: italic;
                color: #979797;
                padding-left: 3em;
                .fa-bell{
                  color: #afaa87
                }
              }
            }

            .tool_args{
              padding: 0 1em 0.5em 2em;

              div{
                margin-top: 16px;
                .required{
                  color: crimson;
                }
              }
            }

            .custom_image{

              .custom_image_checkbox{
                padding-left: 2em;
              }

              .custom_image_input{
                padding: 0.5em 3em;
              }

            }

            .add_tool_button{
              width: 50%;
              margin: 2em 25% 0 25%;
            }
          }

        }


        .criteria-added{
          padding-left: 2em;

          .title{
            padding-top: 5px;
            padding-bottom: 0.7em;
            font-weight: 700;
            text-align: center;
          }

          .criteria_item{
            display: flex;
            align-items: center;
            background: linear-gradient(90deg, #eceff2 0%, #F8F8FA 100%);
            margin-top: 1em;
            padding: 0.5em 1em 0.5em 0.8em;
            border-radius: 5px;
            border: solid 1px #d4dadf;

            .fa-compass {
              color: #495057FF;
              padding-right: 1.5em;
            }

          }

          .tool_item{
            padding: 0.5em 1.2em 0 1.5em;

            .tool_title{
              display: flex;
              padding: 0.3em 0.5em 0.1em 0.5em;
              border-bottom: 1px solid #c7d3dd;

              .tool_name {
                flex-grow: 2;
              }

              .fa-cogs {
                color: #495057FF;
                padding-right: 1.7em;
              }

              .tool_delete .fa-trash{
                font-size: 15px;
                color: #ea6262;
              }
            }

            .tool_data{
              padding-left: 1.5em;
              padding-top: 0.2em;

              .tool_data_title{
                font-size: 0.8em;
                font-weight: bold;
              }
            }


          }

          .no-criteria-selected{
            text-align: center;
            margin-top: 2em;
            color: #300000;
          }

        }

      }

      .create-pipeline-button{
        width: 40%;
        height: 3em;
        margin: 3em 0;
        align-self: center;
        font-size: larger;

        &:disabled{
          cursor: not-allowed;
        }
      }

      .error{
        color: red;
        font-size: 0.75em;
        padding-top: 1em;
        padding-bottom: 1em;
        padding-left: 2.6em;
      }

    }
  }

@media (width < 1600px) {
  .card{
    .card-body{
      .criteria{
        .criteria-input{
          .tool{
            .external_repo{
              .external_repo_input{
                flex-flow: column;
                align-items: flex-start;
              }
            }
          }
        }
      }
    }
  }
}

@media (width < 1000px) {

    .card{
      margin: 1em 0;

      .card-body{

        .criteria-description{
          padding: 2em 2em;
          .icon{ display: none; }
        }

        .custom_envs{
          .custom_envs_input{
            grid: "key key"
                  "value add"
                  / 1fr;
            padding: 0.5em 1em;
            .custom_env_add{
              margin-bottom: 0;
            }
          }
          .custom_envs_added{
            .custom_env_delete{
              margin-bottom: 0;
            }
          }
        }

        .criteria{
          .criteria-input{
            border-right: none;
            padding-right: 1em;

            .tool{
              .external_repo{
                .external_repo_input{
                  flex-flow: column;
                }
              }
            }
          }
          .criteria-added{
            margin-top: 3em;
            padding-left: 1em;
          }
        }

      }
    }

}

@media (width < 600px) {
  .card{
    .card-body{
      .criteria{
        .criteria-input{
          .tool{
            padding-left: 0;
            padding-right: 0;
            .external_repo{
              .external_repo_checkbox{
                padding-left: 0;
              }
              .external_repo_input{
                padding-left: 0;
                padding-right: 0;
              }
              .public_repo{
                padding-left: 0;
              }
            }
            .tool_args{
              padding-left: 0;
            }
            .custom_image{
              .custom_image_checkbox{
                padding-left: 0;
              }
              .custom_image_input{
                padding-left: 0;
                padding-right: 0;
              }
            }
            .add_tool_button{
              width: 80%;
              margin: 2em 10% 0 10%;
            }
          }
        }
      }
    }
  }
}

</style>
